<template>
  <v-text-field
    label="Your response"
    v-model="answer"
    v-on:input="updateAnswer($event)"
    :disabled="disabledAnswers"
  ></v-text-field>
</template>

<script>
  export default {
    name: 'text-answer',
    props: [
      'chosenAnswer',
      'disabledAnswers',
    ],
    data() {
      return {
        answer: null,
      }
    },
    mounted() {
      if (this.chosenAnswer) {
        this.answer = this.chosenAnswer
      }
    },
    methods: {
      updateAnswer (event) {
        this.$emit('updated', event)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/single/TextAnswer.vue